import React from 'react';
import PropTypes from 'prop-types';
import { Marker } from '@geo/react-grabmaps-gl';
import BikeSvg from 'public/images/vehicles/bike.svg';
import CarSvg from 'public/images/vehicles/car.svg';
import VanSvg from 'public/images/vehicles/van.svg';
import SuvSvg from 'public/images/vehicles/suv.svg';
import TrikeSvg from 'public/images/vehicles/trike.svg';
import TruckSvg from 'public/images/vehicles/truck.svg';

export const DRIVER_ICON = {
  BIKE: BikeSvg,
  JUSTEXPRESS: BikeSvg,
  CAR: CarSvg,
  TRUCK: TruckSvg,
  TRIKE: TrikeSvg,
  VAN: VanSvg,
  SUV: SuvSvg,
  BOXPICKUPTRUCK: TruckSvg,
  TRICYCLE: TrikeSvg,
};

const DriverMarker = ({ type, coordinates, bearing }) => {
  const upperCaseType = type.toUpperCase();
  const driverIcon =
    upperCaseType in DRIVER_ICON
      ? DRIVER_ICON[upperCaseType]
      : DRIVER_ICON.BIKE;

  return (
    <Marker
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        willChange: 'transform',
        transform: `rotate(${bearing}deg)`,
      }}
      coordinates={coordinates}
    >
      <img src={driverIcon} alt="driver" />
    </Marker>
  );
};

DriverMarker.propTypes = {
  coordinates: PropTypes.arrayOf(PropTypes.number).isRequired,
  // Add more options such as "CAR" - @wesley.loh
  type: PropTypes.oneOf(['BIKE']),
  bearing: PropTypes.number,
};

DriverMarker.defaultProps = {
  type: '',
  bearing: 0,
};

export default DriverMarker;
